// Copyright (C) 2017-2023 Smart code 203358507

const React = require('react');

const RouteFocusedContext = React.createContext(true);

RouteFocusedContext.displayName = 'RouteFocusedContext';

module.exports = RouteFocusedContext;
